module.exports = __webpack_public_path__ + "img/no-result.b69b5fac.png";